import React, { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaLinkedin, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { useLanguage } from './LanguageContext';
import "./LinktreeModal.css";

const LinktreeModal = ({ isOpen, onClose }) => {
  const { language } = useLanguage();
  const modalRef = useRef(null);

  const name = language === 'ar' ? 'م.مشاري دعجم' : 'Eng. Mishari Dajam';
  const bio = language === 'ar' ? 'هندسة برمجيات' : 'Software Engineering';

  const links = [
    { label: 'LinkedIn', url: "https://www.linkedin.com/in/msharydajam/", icon: <FaLinkedin /> },
    { label: 'Twitter', url: "https://twitter.com/gd_gp_", icon: <FaTwitter /> },
    { label: 'WhatsApp', url: "https://wa.me/966548606667", icon: <FaWhatsapp /> },
  ];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      const handleEsc = (e) => e.key === 'Escape' && onClose();
      document.addEventListener('keydown', handleEsc);
      return () => {
        document.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = '';
      };
    }
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            ref={modalRef}
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.9, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <button className="modal-close" onClick={onClose}>×</button>

            <div className="modal-avatar">M</div>
            <h2 className="modal-name">{name}</h2>
            <p className="modal-bio">{bio}</p>

            <div className="modal-links">
              {links.map((link, i) => (
                <motion.a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-link"
                  whileHover={{ x: 4 }}
                >
                  <span className="link-icon">{link.icon}</span>
                  <span>{link.label}</span>
                </motion.a>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LinktreeModal;
